import React, { useState } from 'react';
import { LL2Map, Lanelet2MapsGroup } from '@tier4/autowareviz-map';
import { TrafficLight } from '@tier4/autowareviz-threejs';
import { useTrafficLightStateArrayBinding } from '@tier4/autowareviz-react-threejs';

export type Lanelet2MapProps = {
    map: Lanelet2MapsGroup;
    //size?: { width: number; height: number };
};

export function Lanelet2Map(props: Lanelet2MapProps) {
    const { map } = props;

    // move camera view point to fit the map
    //const operator = useCameraOperator();
    //useAutoFit(map, size, operator);

    // bind traffic light topic to the corresponding objects
    const [trafficLights, setTrafficLights] = useState<TrafficLight[]>();
    useTrafficLightStateArrayBinding(trafficLights ?? []);

    return <LL2Map map={map} onTrafficLights={setTrafficLights} />;
}
